import Pusher from 'pusher-js';
import { getPusherAuth } from 'services/users';

const pusher = new Pusher('78259d9135d78a1607f4', {
  cluster: 'mt1',
  // userAuthentication: {
  //   customHandler: async ({ socketId }, callback) => {
  //     console.log('user auth ', socketId);
  //     const resp = await getPusherAuth(socketId, 'user');
  //     callback(null, resp);
  //   },
  // },
  channelAuthorization: {
    customHandler: async ({ socketId, channelName }, callback) => {
      const type = channelName.split('-').length > 2 ? 'user' : 'account';
      const { user_data, auth } = await getPusherAuth(socketId, type);
      callback(null, {
        auth,
        channel_data: user_data,
      });
    },
  },
});

pusher.connection.bind('state_change', function (states) {
  console.log(states);
});

pusher.connection.bind('connected', function () {
  console.log('connected');
});
//
// pusher.bind_global((event, data) => {
//   console.log('global', { event, data });
// });

export default pusher;
